import React from 'react';

import PageLayout from '../components/Layout/PageLayout';
import GroupPurchaseManagement from "../components/GroupPurchaseManagement/GroupPurchaseManagement";
const GroupPurchasePage = (props) => {
  return (
    <PageLayout>
        <GroupPurchaseManagement tabId={props.tabId || 'group-purchase'} />
    </PageLayout>
  );
};

export default GroupPurchasePage;